import React, { useEffect, useState } from "react";
import { FaEdit, FaSave } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { AppDispatch, RootState } from "../../redux/Store";
import {
  GetUserDataInUserManagement,
  setEditRow,
} from "../../redux/reducers/UserManagementReducer";
import { Controller, useForm } from "react-hook-form";
import SelectList, { components } from "react-select";
import { useMediaQuery } from "@mui/material";

interface User {
  id: number;
  username: string;
  email: string;
  roles: string[]; // multiple roles
}
const FaEditComponent = FaEdit as React.ComponentType<{
  className?: string;
  title?: string;
  onClick?: () => void;
}>;
const FaSaveComponent = FaSave as React.ComponentType<{
  className?: string;
  title?: string;
  onClick?: () => void;
}>;

const roleOptions = [
  { value: "Admin", label: "Admin" },
  { value: "Editor", label: "Editor" },
  { value: "Viewer", label: "Viewer" },
];

const UserTable: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const EditRow = useSelector(
    (state: RootState) => state.UserManagementReducer.EditRow
  );
  const ShowUserData = useSelector(
    (state: RootState) => state.UserManagementReducer.ShowUserData
  );
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const { watch, register, control } = useForm();

  const [users, setUsers] = useState<User[]>([
    {
      id: 1,
      username: "john_doe",
      email: "john@example.com",
      roles: ["Admin"],
    },
    {
      id: 2,
      username: "jane_smith",
      email: "jane@example.com",
      roles: ["Editor"],
    },
    { id: 3, username: "alice", email: "alice@example.com", roles: ["Viewer"] },
  ]);

  const [editedRoles, setEditedRoles] = useState<{ [id: number]: string[] }>(
    {}
  );

  const handleEdit = (id: any) => {
    dispatch(setEditRow(id));
  };

  const handleSave = (id: number) => {
    //save data with post
    dispatch(setEditRow(null));
  };
  useEffect(() => {
    dispatch(GetUserDataInUserManagement());
  }, []);

  return (
    <div className="mx-4">
      <h2 className="text-xl font-semibold mb-4">User List</h2>
      <div className="overflow-x-auto">
        <table
          className="min-w-full text-sm"
          style={{
            borderCollapse: "collapse",
            width: "100%",
            border: "1px solid gray",
          }}
        >
          <thead style={{ backgroundColor: "#f3f4f6" }}>
            <tr>
              <th style={thStyle}>Username</th>
              <th style={thStyle}>Email</th>
              <th style={{ width: "200px", maxWidth: "100px" }}>Role</th>
              <th style={thStyle}>Action</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => {
              const isEditing = EditRow === user.id;
              return (
                <tr key={user.id}>
                  <td style={tdStyle}>{user.username}</td>
                  <td style={tdStyle}>{user.email}</td>
                  <td
                    style={{
                      border: "1px solid gray",
                      padding: "8px",
                      textAlign: "center",
                    }}
                    className="w-[200px] max-w-[200px] "
                  >
                    {isEditing ? (
                      <div className="w-[200px] max-w-[200px] ">
                        <Controller
                          name="role"
                          control={control}
                          render={({ field }) => {
                            return (
                              <div className="w-full">
                                <SelectList
                                  {...field}
                                  options={roleOptions}
                                  // value={selectedDateList}
                                  isClearable={true}
                                  placeholder="Select role"
                                  hideSelectedOptions={false}
                                  menuPortalTarget={document.body}
                                  // onInputChange={(inputValue: string) => {
                                  //   debouncedSearch(inputValue);
                                  // }}
                                  menuPlacement="auto"
                                  // isMulti
                                  onChange={(e) => {
                                    field.onChange(e);
                                  }}
                                  className="border border-solid border-neutral-300 font-poppins rounded-lg w-full lg:text-[14px] sm:text-[10px]"
                                  components={{
                                    MultiValueContainer: (props) => (
                                      <components.MultiValueContainer
                                        {...props}
                                      >
                                        <div className="flex">
                                          {props.children}
                                        </div>
                                      </components.MultiValueContainer>
                                    ),
                                  }}
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      pointerEvents: "auto",
                                    }),
                                    input: (provided) => ({
                                      ...provided,
                                      position: "relative",
                                      pointerEvents: "auto",
                                      left: 6,
                                      marginRight: "10px",
                                      caretColor: "auto",
                                    }),
                                    option: (provided, state) => ({
                                      ...provided,
                                      backgroundColor:
                                        state.isSelected || state.isFocused
                                          ? "#E6E6E6"
                                          : "",
                                      color: state.isSelected
                                        ? "black"
                                        : "black",
                                    }),
                                    multiValue: (provided) => ({
                                      ...provided,
                                      height: "30px",
                                      display: "flex",
                                      alignItems: "center",
                                      borderRadius: "6px",
                                      minWidth: "none",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 1050, // Ensure dropdown renders above the table
                                      position: "absolute", // Prevent dropdown resizing
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional shadow
                                      // background:"red"
                                    }),
                                    menuPortal: (provided) => ({
                                      ...provided,
                                      // zIndex:1050, // Ensures dropdown renders above all elements
                                    }),
                                    valueContainer: (provided) => ({
                                      position: "relative",
                                      maxWidth: isSmallScreen ? "52vw" : "22vw",
                                      width: "100%",
                                      paddingLeft: "6px",
                                      display: "flex",
                                      alignItems: "center",
                                      height: "40px",
                                      paddingRight: "8px",
                                      overflowX: "auto",
                                      overflowY: "hidden",
                                      minWidth: "50px",
                                      boxSizing: "border-box",
                                      // ...(isFirefox && {
                                      //   maxWidth: "calc(28vw + 10px)",
                                      //   scrollbarWidth: "thin",
                                      // }),
                                    }),
                                    control: (provided) => ({
                                      display: "flex",
                                      // maxWidth:"37vw",
                                      // width:"510px",
                                      height: "40px",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                      width: "100%",
                                    }),
                                    menuList: (provided) => ({
                                      // ...provided,
                                      maxHeight: "200px",
                                      overflow: "hidden",
                                      overflowY: "auto",
                                    }),
                                    clearIndicator: () => ({
                                      // pointerEvents: isLoading ? "none" : "auto",
                                      marginLeft: "15px",
                                      marginTop: "5px",
                                      color: "gray",
                                      cursor:"pointer"
                                    }),
                                  }}
                                />
                              </div>
                            );
                          }}
                        />
                      </div>
                    ) : (
                      user?.roles
                    )}
                  </td>
                  <td style={{ ...tdStyle, textAlign: "center" }}>
                    {isEditing ? (
                      <div
                        onClick={() => handleSave(user.id)}
                        className="text-green-600 font-medium hover:underline cursor-pointer "
                      >
                        <FaSaveComponent />
                      </div>
                    ) : (
                      <div 
                        // onClick={() => {
                        //   dispatch(setEditRow(user.email));
                        // }}
                        onClick={() => handleEdit(user.id)}
                        className="text-blue-500 hover:text-blue-700 cursor-pointer"
                        title="Edit"
                      >
                        <FaEditComponent className="w-4 h-4 inline" />
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
            {users.length === 0 && (
              <tr>
                <td
                  colSpan={4}
                  style={tdStyle}
                  className="text-center text-gray-500 py-4"
                >
                  No users found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const thStyle: React.CSSProperties = {
  border: "1px solid gray",
  padding: "8px",
  textAlign: "center",
};

const tdStyle: React.CSSProperties = {
  border: "1px solid gray",
  padding: "8px",
  textAlign: "center",
};

export default UserTable;
